import { ignoreSlide } from "./ignoreSlide";
import { slides } from "./slides";
export function buildSlides(slideIndexes = []) {
    for (let i = 0, l = slideIndexes.length; i < l; i++) {
        const slideIndex = slideIndexes[i];
        if (ignoreSlide(slideIndex)) {
            // TODO: we'll need to test this to make sure it's still working
            continue;
        }
        const slide = slides[slideIndex];
        if (slide) {
            slide();
        }
    }
}
